import { z } from 'zod';
import { Id, IsoDateTime, TenantId } from './common.ts';

/** Scoped long-term memory. Agents may only propose; validation makes a record usable. */
export const MemoryRecord = z
  .object({
    id: Id,
    tenantId: TenantId,
    scope: z.object({ domain: z.string().min(1), subject: z.string().min(1), purpose: z.string().min(1) }),
    kind: z.enum(['fact', 'preference']),
    fact: z.string().min(1),
    /** Where the fact came from (source id, task id, or `user`). */
    source: z.string().min(1),
    observedAt: IsoDateTime,
    validFrom: IsoDateTime,
    validTo: IsoDateTime.optional(),
    confidence: z.number().min(0).max(1),
    /** Evidence ids supporting the confidence. */
    confidenceEvidence: z.array(z.string()).default([]),
    /** Principal id or agent name that wrote the record. */
    writer: z.string().min(1),
    status: z.enum(['proposed', 'validated', 'rejected', 'expired']),
    expiresAt: IsoDateTime.optional(),
    /** Deletion linkage: deleting `sourceId` expires this record. */
    provenance: z.looseObject({
      sourceId: z.string().optional(),
      sourceVersion: z.string().optional(),
      taskId: Id.optional(),
    }),
    createdAt: IsoDateTime,
  })
  .meta({ id: 'MemoryRecord' });
export type MemoryRecord = z.infer<typeof MemoryRecord>;
